/**
 * Created by Sam on 2020/6/11.
 */
import Vue from 'vue'
import App from './components/App'

new Vue({
  el: '#app',
  render: h => h(App)
})
